/**
 * Black or white, whichever reads on `background`: black when its WCAG relative luminance is above 0.5. The API
 * (StylesheetValue.contrasting_text_color) and the apps derive the default text color on the accent with the same
 * rule. A legacy #AARRGGBB color is read from its last 6 digits.
 */
export const contrastingTextColor = (background: string): '#000000' | '#FFFFFF' => {
  const hex = background.trim().slice(-6);
  const linear = (offset: number) => {
    const channel = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * linear(0) + 0.7152 * linear(2) + 0.0722 * linear(4) > 0.5 ? '#000000' : '#FFFFFF';
};

/** A stylesheet color as CSS, or `fallback` if it isn't one. The app reads legacy 8-digit colors as #AARRGGBB, CSS as #RRGGBBAA */
export const cssColor = (value: string | undefined, fallback: string): string => {
  const hex = value?.trim() ?? '';
  if (/^#[0-9a-f]{6}$/i.test(hex)) return hex;
  if (/^#[0-9a-f]{8}$/i.test(hex)) return `#${hex.slice(3)}${hex.slice(1, 3)}`;
  return fallback;
};
